import API from '@/api'
import { ProgramAPI } from '@/api'

import FertigationStore from './fertigation.store'
import BaseDressingStore from './base-dressing.store'
import TestsStore from './tests.store'
import FertilizersStore from './fertilizers.store';
import StepsStore from './steps.store';
import GeneralSettingsStore from './general-settings.store';
import BlendStore from './blend.store';
import AdjustStore from './adjust.store';
import Gdd from './gdd.store'

export default {

  namespaced: true,

  modules: {
    'fertigation': FertigationStore,
    'base-dressing': BaseDressingStore,
    'tests': TestsStore,
    'fertilizers': FertilizersStore,
    'steps': StepsStore,
    'general-settings': GeneralSettingsStore,
    'blend': BlendStore,
    'adjust': AdjustStore,
    'gdd': Gdd,
  },

  state: {
    data: {},
    isFinished: false,
    canGoToNextStep: true,
  },

  mutations: {

    saveProgram(state, data) {
      state.data = data;
    },

    toggleIsFinished(state, data) {
      if(data) {
        state.isFinished = true;
      } else {
        state.isFinished = false;
      }
    },

    setFieldValue(state, data) {
      state.data = {
        ...state.data,
        ...data
      };
    },
    saveCanGoToNextStep(state, data) {
      state.canGoToNextStep = data;
    },
  },

  actions: {

    getPdfForProgram({ commit, dispatch, state, rootGetters }, program_id) {
      // let pdfs = rootGetters['user/availablePrograms'].data;
      return API.reports.load({page:1, take:9999})
      .then( res => {
        let pdfs = res.data.pdfs;
        let data = pdfs.find(x => x.programId == program_id);
        commit('toggleIsFinished', data);
      })

    },

    canGoToNextStep({commit}, payload) {
      commit('saveCanGoToNextStep', payload);
    },

    async loadProgramById({ commit, dispatch, state, rootGetters }, program_id) {
      const prog = await ProgramAPI.getProgramById(program_id)
        .then(res => res.data.data)
      commit('saveProgram', prog);

      let step = prog.currentStep;

      if(!rootGetters['program/steps/data'].find(n => n.key === step)) {
        step = null;
      }

      commit('program/steps/setCurrentStep', step, { root: true });
      // commit('program/steps/setCurrentStepNextFromSelectedStep', step, { root: true });
    },

    destroyState({ state, commit, dispatch }) {
      state.data = {};

      dispatch('program/fertigation/destroyState', '', { root: true });
      dispatch('program/base-dressing/destroyState', '', { root: true });
      dispatch('program/tests/destroyState', '', { root: true });
      dispatch('program/blend/destroyState', '', { root: true });
      dispatch('program/fertilizers/destroyState', '', { root: true });
    },
  },

  getters: {

    // везде где get* в названии должны функцуию возвращать

    data(state) {
      return state.data;
    },

    programId(state) {
      return state.data.id
    },
    isFinished(state) {
      return state.isFinished;
    },
    canGoToNextStep(state) {
      return state.canGoToNextStep;
    }
  },
}
